
export enum Conta {
    CORRENTE = 'Corrente',
    POUPANCA = 'Poupança'

  }
  